"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const setCustomerNoteMutation_1 = __importDefault(require("./graphql/setCustomerNoteMutation"));
const getCustomerNoteQuery_1 = __importDefault(require("./graphql/getCustomerNoteQuery"));
class CustomerNotes {
    constructor(client) {
        this.getCustomerNote = async (_token, customerId) => {
            const data = await this.client.post("/graphql", {
                operationName: "getCustomerNote",
                query: getCustomerNoteQuery_1.default,
                variables: {
                    id: parseInt(customerId),
                },
            });
            if (data.errors) {
                return {
                    body: "",
                };
            }
            return {
                body: data.data.coachTrainee.coachComments || "",
            };
        };
        this.setCustomerNote = async (_token, customerId, note) => {
            await this.client.post("/graphql", {
                operationName: "setCustomerNote",
                query: setCustomerNoteMutation_1.default,
                variables: {
                    customerId: parseInt(customerId),
                    note,
                },
            });
        };
        this.client = client;
    }
}
exports.default = CustomerNotes;
//# sourceMappingURL=CustomerNotes.js.map